import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { store } from "../../_store";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import SettingsPanel from "./settingsPanel";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services/common.service";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
// import Table from "components/Table/Table.jsx";
import { connect } from "react-redux";
import Tabs from "components/CustomTabs/CustomTabs.jsx";
import Seat from "@material-ui/icons/AirlineSeatFlat";
import Airline from "@material-ui/icons/AirlineSeatReclineNormal";
import ApprovedTable from "./approvedTable";
import AllPscTable from "./allCharges";
import { appConstants } from "../../_constants";
import CircularProgress from "../../utils/CircularProgress";
import { Grid, TextField, FormControl, InputLabel, Select, Input, MenuItem } from "@material-ui/core";
import InlineDatePicker from "../../utils/InlineDatePicker";
import { appHelpers } from "../../_helpers";


const styles = (theme) => ({
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0",
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF",
        },
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1",
        },
    },
    negativeColor: {
        color: "red",
    },
    positiveColor: {
        color: "green",
    },
    nb: {
        color: "red",
        fontSize: "12px",
    },
    wide: {
        width: "100%",
        minWidth: "300px",
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120
      },
});

class PscSettingsTable extends React.Component {
    state = {
        page: 0,
        response: "",
        rowsPerPage: 10,
        open: false,
        openApprove: false,
        airlineName: "",
        airlineId: "",
        PscChargePendingId: "",
        pendingRecord: "",
        recordCreatedBy: "",
        newRecordCharge: "",
        oldRecordCharge: "",
        revenueCharge: "",
        currencyCharge: "",
        serviceTypeCharge: "",
        ApprovedBy: "",
        pscData: [],
        pendingPscData: [],
        openModal: false,
        currentPSCRegionalCharge: "",
        currentPSCInternationalCharge: "",
        oldPsc: "",
        errorMessage: "",
        errorComponent: false,
        editErrorComponent: false,
        users: [],
        PageCount: 10,
        currentPage: 1,
        currentPagePending: 1,
        TotalCount: 0,
        totalCountPending: 0,
        error: false,
        formError: "",
        requestingFlights: true,
        reason: "",
        comment: "",
        Status: "",
        openComment: false,
        pscPendingId: "",
        currentTab: 0,
        startDateNew: new Date(),
        startDateEdit: new Date(),
        revenue: "",
        pscChargesOld: "",
        pscChargesNew: "",
        revenueLine: "",
        currencyOptions: [],
        currency: "",
        serviceTypesOptions: [],
        serviceType: "",
        componentErrorMessages: [],
    };

    componentDidMount() {
        let { users, currencies, serviceTypes, } = store.getState();
        const { dispatch } = this.props;

        if (users) {
            this.setState({ users: users.ResultList });
        } else {
            dispatch(commonActions.getAllUsers());
        }

        if (currencies) {
            this.setState({ currencyOptions: currencies });
        } else {
            dispatch(commonActions.getAllCurrencies());
        }

        if (serviceTypes) {
            this.setState({ serviceTypesOptions: serviceTypes });
        } else {
            dispatch(commonActions.getAllServiceTypes());
        }

        this.getAllPsc();
        this.getAllUnprocessedPendingPsc();
        this.getCurrentPsc({ serviceType: 1 }, "currentPSCRegionalCharge");
        this.getCurrentPsc({ serviceType: 2 }, "currentPSCInternationalCharge");
    }

    componentWillReceiveProps = function (nextProps) {
        const { regionalAirlines, users, currencies, serviceTypes } = nextProps;
        if (regionalAirlines) {
            this.setState({ airlinesData: regionalAirlines.Results });
        }
        if (users) {
            this.setState({ users: users.ResultList });
        }

        if (currencies !== this.props.currencies) {
            this.setState({ currencyOptions: currencies });
        }

        if (serviceTypes !== this.props.serviceTypes) {
            this.setState({ serviceTypesOptions: serviceTypes });
        }
    };

    //Get currrent Psc
    //TODO: replace currentPsc with [attribute]

    getCurrentPsc = (payload, attibute) => {
        const { dispatch } = this.props;
        commonService
            .getCurrentPscRegional(payload)
            .then((getPsc) => {
                if (getPsc.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({ [attibute]: getPsc.response.PscCharge });
                } else if (getPsc.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(getPsc.response));
                    this.setState({ pageRequesting: false });
                }
            })
            .catch((err) => {
                // dispatch(alertActions.error(err.response));
            });
        dispatch(alertActions.clear());
    };

    //Get All PSC Charge
    getAllPsc = (pageNumber) => {
        const { dispatch } = this.props;
        const { PageCount } = this.state;
        let fromIndex;
        if (pageNumber === undefined) {
            fromIndex = 1;
            pageNumber = 1;
        } else {
            fromIndex = pageNumber;
        }
        dispatch(alertActions.startRequest());
        commonService
            .getAllPscRegional(fromIndex, PageCount)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        pageRequesting: false,
                        currentPage: pageNumber,
                        pscData: res.response.PendingPscCharge,
                        TotalCount: res.response.TotalCount,
                    });
                } else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            })
            .catch((err) => {
                dispatch(alertActions.error(err.response));
            });
        dispatch(alertActions.clear());
    };

    //Get All PSC Charge
    getAllUnprocessedPendingPsc = (pageNumber) => {
        const { dispatch } = this.props;
        const { PageCount} = this.state;
        let fromIndex;
        if (pageNumber === undefined) {
            fromIndex = 1;
            pageNumber = 1;
        } else {
            fromIndex = pageNumber;
        }
        let serviceType = 1

        dispatch(alertActions.startRequest());
        //TODO: change 1 to service type
        commonService
            .getAllUnprocessedPendingPscRegional(fromIndex, PageCount, serviceType)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.stopRequest());
                    this.setState({
                        pageRequesting: false,
                        currentPagePending: pageNumber,
                        pendingPscData: res.response.PendingPscCharge,
                        totalCountPending: res.response.TotalCount,
                    });
                } else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ pageRequesting: false });
                }
            })
            .catch((err) => {
                dispatch(alertActions.error(err.response));
            });
        dispatch(alertActions.clear());
    };

    //Save new PSC value Button
    handlePscSave = () => {
        const {
            pscChargesNew,
            pscChargesOld,
            startDateNew,
            revenueLine,
            currency,
            serviceType
        } = this.state;
        const { user, dispatch } = this.props;
        let Currency = currency === "-1" ? "" : currency.value;
        let ServiceType = serviceType === "-1" ? "" : serviceType.value;

if (this.validateInput()) {
        let payload = {
            OldCharges: pscChargesOld,
            NewCharges: pscChargesNew,
            CreatedBy: user.userId,
            StartDate: appHelpers.formatDateSpecific(startDateNew, "YYYY-MM-DD"),
            RevenueLine: revenueLine,
            Currency,
            ServiceType
        };
        dispatch(alertActions.startRequest());
        commonService
            .savePscRegional(payload)
            .then((res) => {
                if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ formError: res.response, error: true });
                } else if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.stopRequest());
                    dispatch(alertActions.notify("Saved Successfully"));
                    this.getAllPsc();
                    this.getAllUnprocessedPendingPsc();
                    this.getCurrentPsc({ serviceType: 1 }, "currentPSCRegionalCharge");
                    this.getCurrentPsc(
                        { serviceType: 2 },
                        "currentPSCInternationalCharge"
                    );
                    this.setState({ openModal: false, editErrorComponent: false });
                }
            })
            .catch((err) => {
                dispatch(alertActions.error(err.response));
            });
        dispatch(alertActions.clear());
}
    };

    //Handle Input
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleReactSelectChange = (value, name) => {
        this.setState({ [name.name]: value });
        if (
            value.value === undefined ||
            value.value === "-1" ||
            value.value === ""
        ) {
            this.setState({ [name.name]: "-1" });
        }
    };
    //Open Set New PSC Modal
    handlePsc = () => {
        this.setState({ openModal: true });
    };

    handleClose = () => {
        this.setState({
            openModal: false,
            openApprove: false,
            open: false,
            openComment: false,
        });
        this.resetForm();
    };

    resetForm = () => {
        this.setState({
            pscChargesNew: "",
            revenueLine: "",
            currency: "",
            pscChargesOld: "",
            serviceType: "",
            componentErrorMessages: [],   
            editErrorComponent: false    
        });

    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleSelectChange = (prop) => (event) => {
        this.setState({ [prop]: event.target.value });
    };
    handleEdit = (item) => {
        const { Id, OldCharges, NewCharges, CreatedBy, Currency, RevenueLine, ServiceType } = item;
        this.setState({
            open: true,
            pendingRecord: Id,
            oldRecordCharge: OldCharges,
            newRecordCharge: NewCharges,
            recordCreatedBy: CreatedBy,
            currencyCharge: Currency,
            revenueCharge: RevenueLine,
            serviceTypeCharge: ServiceType
        });
    };

    handleEditPsc = () => {
        const {
            pendingRecord,
            oldRecordCharge,
            newRecordCharge,
            recordCreatedBy,
            revenueCharge,
            startDateEdit,
            currencyCharge,
            serviceTypeCharge
        } = this.state;
        const { dispatch } = this.props;
        // let Currency = currencyCharge === "-1" ? "" : currencyCharge.value;
        // let ServiceType = serviceTypeCharge === "-1" ? "" : serviceTypeCharge.value;
        if(this.validateEdit()) {
        let payload__ = {
            PscChargePendingId: pendingRecord,
            OldCharges: oldRecordCharge,
            NewCharges: newRecordCharge,
            CreatedBy: recordCreatedBy,
            StartDate: appHelpers.formatDateSpecific(startDateEdit, "YYYY-MM-DD"),
            RevenueLine: revenueCharge,
            Currency: currencyCharge,
            ServiceType: serviceTypeCharge
        };
        dispatch(alertActions.startRequest());
        commonService
            .editPscRegional(payload__)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({
                        errorMessage: res.response,
                        editErrorComponent: true,
                    });
                } else if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify(res.response));
                    this.getAllPsc();
                    this.getAllUnprocessedPendingPsc();
                    this.getCurrentPsc({ serviceType: 1 }, "currentPSCRegionalCharge");
                    this.getCurrentPsc(
                        { serviceType: 2 },
                        "currentPSCInternationalCharge"
                    );
                    this.setState({ open: false, editErrorComponent: false });
                }
            })
            .catch((err) => {
                dispatch(alertActions.error(err.response));
            });
        dispatch(alertActions.clear());
        }
    };
//method to convert serviceType Id to name
filterServiceType = (serviceType) => {
    const { serviceTypesOptions } = this.state;
        let serviceName = serviceTypesOptions.find(item => item.Id === serviceType);
        if (serviceName) {
            return `${serviceName.Name}`
        } else {
            return 'Unknown'
        }

    }

    //validate Input
    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if (this.state.pscChargesNew === "") {
            _errs_["pscChargesNew"] = "valid new charge is required";
            formValid = false;
        }

        if (this.state.pscChargesOld === "") {
            _errs_["pscChargesOld"] = "valid old charge is required";
            formValid = false;
        }
        
        
        if (this.state.revenueLine === "") {
            _errs_["revenueLine"] = "valid revenue line is required";
            formValid = false;
        }
        if (this.state.currency === "") {
            _errs_["currency"] = "valid currency is required";
            formValid = false;
        }
        if (this.state.serviceType === "") {
            _errs_["serviceType"] = "valid service Type is required";
            formValid = false;
        }
        this.setState({componentErrorMessages: _errs_});
        return formValid;
    };

    validateEdit = () => {
        let _errs_ = [];
        let formValid = true;
        if (this.state.newRecordCharge === "" ) {
            _errs_["newRecordCharge"] = "valid new charge is required";
            formValid = false;
        }
        if (this.state.revenueCharge === "" ) {
            _errs_["revenueCharge"] = "valid revenue line is required";
            formValid = false;
        }
        if (this.state.currencyCharge === "" ) {
            _errs_["currencyCharge"] = "valid currency is required";
            formValid = false;
        }
        if (this.state.serviceTypeCharge === "" ) {
            _errs_["serviceTypeCharge"] = "valid service type is required";
            formValid = false;
        }
        this.setState({componentErrorMessages: _errs_});
        return formValid;
    }
    //Approve/Decline Psc Charge
    handleApprove = (status, id) => {
        this.setState({
            pscPendingId: id,
            status: status,
            openComment: true,
        });
        status === 0 && this.setState({ reason: "Decline" });
        status === 1 && this.setState({ reason: "Approval" });
    };
    //Comment Modal
    openSubmitComment = () => {
        const { user, dispatch } = this.props;
        const { pscPendingId, status, comment } = this.state;
        let payload = {
            PscChargePendingId: pscPendingId,
            ApprovedBy: user.userId,
            Status: status,
            Comment: comment,
        };
        dispatch(alertActions.startRequest());
        commonService
            .approvePscRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    status === 0 &&
                        dispatch(alertActions.notify("PSC Charge Declined Successfully"));
                    status === 1 &&
                        dispatch(alertActions.notify("PSC Charge Approved Successfully"));
                    this.getAllPsc();
                    this.getAllUnprocessedPendingPsc();
                    this.getCurrentPsc({ serviceType: 1 }, "currentPSCRegionalCharge");
                    this.getCurrentPsc(
                        { serviceType: 2 },
                        "currentPSCInternationalCharge"
                    );
                    this.setState({
                        openApprove: false,
                        openComment: false,
                        comment: "",
                    });
                } else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ errorMessage: res.response });
                }
            })
            .catch((err) => {
                dispatch(alertActions.error(err.response));
            });
        dispatch(alertActions.clear());
    };

    filterUsers = (userId) => {
        const { users } = this.state;
        if (users) {
            let userName = users.find((u) => u.Id === userId);
            if (userName) {
                return `${userName.FirstName} ${userName.LastName}`;
            } else {
                return "Unknown User"; //`Unknown User`;
            }
        }
    };

    selectedTab = (key) => {
        this.setState({ currentTab: key });
    };

    render() {
        const { classes, fullScreen, requesting } = this.props;
        const {
            pageRequesting,
            airlines,
            name,
            formError,
            currentPagePending,
            currentPage,
            error,
            pendingPscData,
            currentPSCRegionalCharge,
            currentPSCInternationalCharge,
            errorComponent,
            errorMessage,
            currencyOptions,
            currency,
            serviceTypesOptions,
            serviceType,
            openModal,
            pscData,
            reason,
            revenueLine,
            comment,
            currencyCharge,
            serviceTypeCharge,
            startDateEdit,
            componentErrorMessages
        } = this.state;


        if (pageRequesting) return <CircularProgress />;
        return (
            <GridContainer>
                <SettingsPanel
                    classes={this.props.classes}
                    errorComponent={errorComponent}
                    formError={formError}
                    componentErrorMessages={componentErrorMessages}
                    error={error}
                    errorMessage={errorMessage}
                    openModal={openModal}
                    handleChange={(event) => this.handleChange(event)}
                    handlePsc={this.handlePsc}
                    currentPSCRegionalCharge={currentPSCRegionalCharge}
                    currentPSCInternationalCharge={currentPSCInternationalCharge}
                    airlines={airlines}
                    handleDateChange={this.handleDateChange}
                    airline={name}
                    handleClose={this.handleClose}
                    serviceTypesOptions={serviceTypesOptions}
                    serviceType={serviceType.value}
                    handlePscSave={this.handlePscSave}
                    disabled={requesting}
                    currencyOptions={currencyOptions}
                    currency={currency.value}
                    revenueLine={revenueLine}
                    reactSelectChange={this.handleReactSelectChange}
                />
                <Tabs
                    headerColor="regional"
                    tabs={[
                        {
                            tabName: "All PSC Settings",
                            tabIcon: Airline,
                            clickEvent: (key) => this.selectedTab(key),
                            tabContent: (
                                <GridItem xs={12} sm={12} md={12}>
                                    <ApprovedTable
                                        records={pscData}
                                        fetchRecords={this.getAllPsc}
                                        classes={this.props.classes}
                                        totalCounts={this.state.TotalCount}
                                        filterUsers={this.filterUsers}
                                        currentPage={currentPage}
                                        pageSize={this.state.PageCount}
                                        user={this.props.user}
                                        filterServiceType={this.filterServiceType}
                                    />
                                </GridItem>
                            ),
                        },
                        {
                            tabName: "Pending Settings",
                            tabIcon: Seat,
                            clickEvent: (key) => this.selectedTab(key),
                            tabContent: (
                                <GridItem xs={12} sm={12} md={12}>
                                    <AllPscTable
                                        handleApprove={this.handleApprove}
                                        records={pendingPscData}
                                        fetchRecords={this.getAllUnprocessedPendingPsc}
                                        handleEdit={this.handleEdit}
                                        handleApproveThreshold={this.openApprove}
                                        classes={this.props.classes}
                                        totalCounts={this.state.totalCountPending}
                                        filterUsers={this.filterUsers}
                                        currentPage={currentPagePending}
                                        pageSize={this.state.PageCount}
                                        user={this.props.user}
                                        filterServiceType={this.filterServiceType}
                                    />
                                </GridItem>
                            ),
                        },
                    ]}
                />

                {/*// Edit Modal*/}
                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle
                        id="responsive-dialog-title"
                        style={{ backgroundColor: "#66bb6a" }}
                    >
                        <span style={{ color: "white", textTransform: "uppercase" }}>
                            Edit PSC Charge
            </span>
                    </DialogTitle>
                    <DialogContent>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <CustomInput
                                    disabled
                                    required
                                    labelText="Old Charge"
                                    id="oldRecordCharge"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        disabled: true,
                                        value: this.state.oldRecordCharge,
                                        name: "oldRecordCharge",
                                        type: "number",
                                        onChange: this.handleChange,
                                    }}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <CustomInput
                                    labelText="New Charge"
                                    id="newRecordCharge"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        required: true,
                                        value: this.state.newRecordCharge,
                                        name: "newRecordCharge",
                                        type: "number",
                                        onChange: this.handleChange,
                                    }}
                                />
                                {componentErrorMessages.newRecordCharge && <span style={{color: "red"}}>{componentErrorMessages.newRecordCharge}</span>}

                                {/* {editErrorComponent && (
                                    <div style={{ color: "red", fontSize: "13px" }}>
                                        {errorMessage}
                                    </div>
                                )} */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12} style={{ marginTop: "15px" }}>
                                <FormControl fullWidth>
                                    <InlineDatePicker
                                        Date={startDateEdit}
                                        handleDateChange={(date) =>
                                            this.handleDateChange(date, "startDateEdit")
                                        }
                                        label="Start Date"
                                        minDate={Date()}
                                    />
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl
                                    fullWidth
                                    // className={classes.formControl}
                                    >
                                    <CustomInput
                                        required
                                        labelText="Revenue Line"
                                        id="revenueCharge"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={
                                            {
                                                name: "revenueCharge",
                                                value: this.state.revenueCharge,
                                                type: "text",
                                                onChange: this.handleChange,
                                            }}
                                    />
                                </FormControl>
                                {componentErrorMessages.revenueCharge && <span style={{color: "red"}}>{componentErrorMessages.revenueCharge}</span>}

                            </GridItem>

                            <GridItem xs={12} sm={12} md={12} >
                                <FormControl
                                    fullWidth
                                    // className={classes.formControl}
                                    >
                                    <InputLabel shrink htmlFor="age-simple">
                                        Select Currency
                </InputLabel>
                <Select
                                            value={currencyCharge}
                                            onChange={(e)  => this.handleChange(e)}
                                            name="currencyCharge"
                                            input={
                                                <Input name="airline" id="airline-label-placeholder" />
                                            }
                                        >
                                            <MenuItem value="Placeholder">Select Currency</MenuItem>
                                            {currencyOptions.map((option, i) => (
                                                <MenuItem
                                                    key={i}
                                                    value={option.Id}
                                                    className={classes.select}
                                                >
                                                    {option.Id}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                </FormControl>
                                {componentErrorMessages.currencyCharge && <span style={{color: "red"}}>{componentErrorMessages.currencyCharge}</span>}

                            </GridItem>

                            <GridItem xs={12} sm={12} md={12} style={{ marginTop: "15px" }}>
                                <FormControl
                                    fullWidth
                                    // className={classes.formControl}
                                    >
                                    <InputLabel shrink htmlFor="age-simple">
                                        Service Type
                </InputLabel>
                                    <Select
                                    value={serviceTypeCharge}
                                    onChange={(e)=> this.handleChange(e)}
                                    name="serviceTypeCharge"
                                    input={
                                        <Input name='airline' id='airline-label-placeholder'/>
                                    }
                                    >
                                    <MenuItem
                                    value="Placeholder">Select Service Type
                                    </MenuItem>
                                    {serviceTypesOptions.map((option, i) =>(
                                        <MenuItem
                                        key={i}
                                        value={option.Id}
                                        className={classes.select}
                                        >
                                            {option.Name}
                                        </MenuItem>
                                    ))}
                                    </Select>
                                </FormControl>
                                {componentErrorMessages.serviceTypeCharge && <span style={{color: "red"}}>{componentErrorMessages.serviceTypeCharge}</span>}
                            </GridItem>
                        </GridContainer>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="danger">
                            Cancel
            </Button>
                        <Button onClick={this.handleEditPsc} color="success" autoFocus>
                            Submit
            </Button>
                    </DialogActions>
                </Dialog>

                {/*//Comment Modal*/}
                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.openComment}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle
                        id="responsive-dialog-title"
                        style={{ backgroundColor: "#04137b" }}
                    >
                        <span style={{ color: "white", textTransform: "uppercase" }}>
                            Reason for {reason}
                        </span>
                    </DialogTitle>
                    <DialogContent>
                        <GridContainer>
                            <Grid item md={12} sm={12}>
                                <TextField
                                    style={{
                                        width: "100%",
                                        minWidth: "300px",
                                    }}
                                    // disabled = {disabled}
                                    // disabled={disabled}
                                    multiline
                                    rowsMax="10"
                                    id="email"
                                    label="Reason"
                                    name="comment"
                                    value={comment}
                                    onChange={this.handleChange}
                                    margin="normal"
                                    variant="outlined"
                                />
                                <div
                                    style={{
                                        color: "red",
                                        fontSize: "12px",
                                    }}
                                >
                                    *State your reason
                </div>
                                {/*<span>*/}
                                {/*<Button onClick={this.handleActiveInput} color="success" autoFocus>*/}
                                {/*Edit*/}
                                {/*</Button>*/}
                                {/*</span>*/}
                            </Grid>
                        </GridContainer>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.openSubmitComment} color="regional" autoFocus>
                            Submit
            </Button>
                    </DialogActions>
                </Dialog>
            </GridContainer>
        );
    }
}

PscSettingsTable.defaultProps = {
    tableHeaderColor: "gray",
};

PscSettingsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    tableHeaderColor: PropTypes.oneOf([
        "warning",
        "regional",
        "primary",
        "danger",
        "success",
        "info",
        "rose",
        "gray",
    ]),
    tableHead: PropTypes.arrayOf(PropTypes.string),
    tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
};
const mapStatesToProps = (state) => {
    const {
        modal,
        alert,
        regionalAirlines,
        progress,
        user,
        users,
        requesting,
        currencies,
        serviceTypes
    } = state;

    return {
        modal,
        alert,
        regionalAirlines,
        progress,
        user,
        users,
        requesting,
        currencies,
        serviceTypes
    };
};

export default connect(mapStatesToProps)(withStyles(styles)(PscSettingsTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/PscSettings/Index.jsx